import axios from "../../lib/axiosInstance";

export function fetchAllCompanyDesignations() {
  return axios.get(`designations`).then((res) => res.data);
}

export function createDesignation(payload) {
  return axios.post(`designations`, payload).then((res) => res.data);
}

export function updateDesignation(payload) {
  const { id, ...rest } = payload;
  return axios.patch(`designations/${id}`, rest).then((res) => res.data);
}

export function createDesignationPermissions(payload) {
  return axios
    .post(`designations/permissions`, payload)
    .then((res) => res.data);
}

export function fetchAllPermissionsByDesignation(designationId) {
  return axios.get(`designations/${designationId}`).then((res) => res.data);
}
